module.exports = __webpack_public_path__ + "img/tour-50.44e287f8.png";